import type { FaireProductEntity } from "../../entity_types/product";

export const p_bhbw3ppzm9: FaireProductEntity = {
  token: "p_bhbw3ppzm9",
  type: "product",
  name: "2 lbs Natural Iridescent Goethite Rough Crystal Healing",
  brandToken: "b_edj9u7j4sq",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/78b579a9dd8fee7b70956e2195937c406533a536b67e9569fbf61b8ea539db61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f693f1ba94ab9ae9fc7e866c523442ff16ca3e9911876555fa7516abe453f08d.jpeg",
    "https://cdn.faire.com/fastly/cf57c10f471be8d7d8a73e9ef7499937dd7ebac40df1eee320bc3b34f883d570.jpeg",
    "https://cdn.faire.com/fastly/a16c2d782ff27fd921bc1afb0f5fc503b032f4ddb8508b4bdef8dda91a21023e.jpeg",
    "https://cdn.faire.com/fastly/875388b59eeae89b253e1eb84bc54ffb0fb60b290bf3ccfb1215301f6bbc11af.jpeg",
    "https://cdn.faire.com/fastly/46c00dd7b10dff3720f6c7e20b2bf06951def8d742e4afdb982a104e9d0da6ea.jpeg",
  ],
  priceDollars: 76.22,
  description:
    "Add a striking metallic shimmer to your inventory with these natural iridescent goethite rough crystals. Each lot includes approximately 2 lbs of raw specimens, showcasing captivating rainbow-like iridescence layered over deep earthy tones.\n\nThese unique formations are highly sought after for their natural texture, reflective surfaces, and bold visual appeal—perfect for collectors, crystal shops, or display pieces.\n\nGoethite forms through natural mineral processes and may feature organic shapes, uneven surfaces, and natural imperfections that highlight its authenticity and raw beauty.\n\nPerfect for resale, display, or adding a distinctive edge to any crystal collection.\n\nLocal pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.",
  tags: [],
  msrpDollars: 152.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:15.909Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
